import { ModalBody, ModalFooter, Text } from "@chakra-ui/react";
import PrimaryButton from "components/PrimaryButton";
import { modalPadding } from "./EmailVerificationForm";

export type ConfirmationModalProps = {
  existingUserName: string | null | undefined;
  newUserName: string | undefined;
  onClose: () => void;
};

const ConfirmationModal = ({
  existingUserName,
  newUserName,
  onClose,
}: ConfirmationModalProps) => {
  return (
    <>
      <ModalBody p={modalPadding}>
        <Text textStyle="body2" color="gray.500" p={6}>
          An invite has been sent to{" "}
          {existingUserName ? existingUserName : newUserName}&apos;s email.
        </Text>
      </ModalBody>
      <ModalFooter pb={8}>
        <PrimaryButton mr={3} onClick={onClose}>
          Close
        </PrimaryButton>
      </ModalFooter>
    </>
  );
};

export default ConfirmationModal;
